import React, { useState } from 'react';
import { Card, CardContent, Grid, Typography, AppBar, Toolbar, InputBase, Avatar } from '@mui/material';

// import Navbar from "./Navbar";
import BreaksComp from '../components/breaks/Index.jsx';



const Breaks = () => {
 
  return (
    <div>
      {/* <Navbar /> */}
      <BreaksComp />
      
    </div>
  );
};

export default Breaks;
